import React from "react";
import { ReserveFieldTime } from "@/features/reserve/components/ReserveFieldTime/ReserveFieldTime";
import { useReserveForm } from "@/features/reserve/components/Reserve/ReserveFormProvider";

export const ReserveFormStartTime: React.FC = () => {
  const { form, weekDates, defaultValues, office, setStartTime } =
    useReserveForm();
  return (
    <ReserveFieldTime
      form={form}
      defaultValue={defaultValues.time}
      office={office || null}
      errors={form.formState.errors}
      setStartTime={setStartTime}
      weekDates={weekDates}
    />
  );
};
